var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDragonCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.47523 54.54496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .a {\r\n        fill: #fff;\r\n      }\r\n\r\n      .b, .c {\r\n        fill: #54868f;\r\n        stroke: #fff;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .b {\r\n        stroke-width: 2.66136px;\r\n      }\r\n\r\n      .c {\r\n        stroke-width: 1.29112px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M29.22837,22.88619s-5.60976-.89246-5.09979-3.95233a2.62159,2.62159,0,0,1,1.63652-2.389l.72133.62515.57453-2.316s-6.11974-2.54989-6.24723,3.56985S29.22837,22.88619,29.22837,22.88619Z",
    transform: "translate(-7.10884 -1.20416)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.70293,25.22965c2.03992,1.40244,9.99584.63862,10.10691,3.58184-.1666,3.41525-5.825.17449-5.825.17449a6.72748,6.72748,0,0,0-.61678.88063c.74969.66639,6.36533,6.0001,9.34683.37371.727-3.52056-2.04431-5.01067-3.50277-5.58916C30.99813,23.773,29.83549,25.50386,23.70293,25.22965Z",
    transform: "translate(-7.10884 -1.20416)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.1217,33.74575s5.55324.88846,5.04326,3.94833a2.60922,2.60922,0,0,1-1.58,2.393l-.72133-.62516-.57453,2.316s6.20783,2.5511,6.24723-3.56985C32.57927,31.53872,24.1217,33.74575,24.1217,33.74575Z",
    transform: "translate(-7.10884 -1.20416)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M29.4535,32.35623c-2.03992-1.40244-10.05709-.59256-10.16815-3.53578.16659-3.41524,5.825-.17448,5.825-.17448a6.72752,6.72752,0,0,0,.61677-.88063c-.74969-.66639-6.58257-5.80987-9.498-.50652-.727,3.52056,2.1955,5.14348,3.654,5.722C22.09705,33.859,23.10578,32.30814,29.4535,32.35623Z",
    transform: "translate(-7.10884 -1.20416)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 1.33068,
    y: 1.33068,
    width: 39.81387,
    height: 51.88359,
    rx: 1.71772
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 6.4778,
    y: 5.9263,
    width: 29.51964,
    height: 42.69236,
    rx: 0.95876
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M30.30389,27.97274s-9.31763-2.91668-7.74812-9.24365a5.47435,5.47435,0,0,1,3.32755-4.70936L26.964,15.466l1.508-4.7538S18.6699,4.22211,17.0459,17.04209,30.30389,27.97274,30.30389,27.97274Z",
    transform: "translate(-7.10884 -1.20416)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.7372,28.18c2.618,3.7482,16.16888,5.63686,14.77511,11.69552C32.407,46.77779,24.7971,37.707,24.7971,37.707a14.625,14.625,0,0,0-1.4907,1.53105c.88122,1.68583,7.29886,15.0122,15.2388,4.81457,3.08749-6.87442-.69165-11.11869-2.79073-12.93223C32.568,28.36739,29.72,31.39815,19.7372,28.18Z",
    transform: "translate(-7.10884 -1.20416)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.799,14.40241l1.19323,2.21482L28.81,9.71523l.15956,7.659.757-.07141,1.81488-8.059.15607,7.73471,1.75887-2.02882a6.50915,6.50915,0,0,1-2.33491,5.57663l-.0804,1.56149-1.09544.88942-.24141,2.505-1.36758,1.08512L27.1683,25.14047l.25507-2.32749-1.13359-1.24587.17-1.55166A10.5913,10.5913,0,0,1,25.799,14.40241Z",
    transform: "translate(-7.10884 -1.20416)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 16.8782,
    cy: 36.90461,
    rx: 1.81856,
    ry: 2.24833
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragonCard);
export default __webpack_public_path__ + "static/media/DragonCard.08c1b75d9b9eef225cfc215c66f3a0f4.svg";
export { ForwardRef as ReactComponent };